function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-star",
  "data-name": "Icon awesome-star",
  d: "M7.724.468,6.006,3.951l-3.844.56A.842.842,0,0,0,1.7,5.948l2.781,2.71L3.82,12.486a.841.841,0,0,0,1.221.887l3.439-1.807,3.439,1.807a.842.842,0,0,0,1.221-.887l-.658-3.828,2.781-2.71A.842.842,0,0,0,14.8,4.511l-3.844-.56L9.234.468a.843.843,0,0,0-1.51,0Z",
  transform: "translate(-0.678 0.751)",
  fill: "#32dea5",
  stroke: "#32dea5",
  strokeWidth: 1.5
});

function SvgWishlistGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.602,
    height: 14.991,
    viewBox: "0 0 15.602 14.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistGreen);
export default __webpack_public_path__ + "static/media/wishlist-green.a230f4c4.svg";
export { ForwardRef as ReactComponent };